export class ChangeControlActionItem {
    ActionItemNumber!: string;
    Title!: string;
    Type!: any;
    Description!: string;
    DueDate!: any;
    IsRiskAssessmentRequired!: boolean;
    IsVerificationRequired!: boolean;
    Assignee!: string;
    Verifier!: string;
    Status!: any;
    ActionTaken!: string;
    VerificationNotes!: string;
    Attachments!: any;
}
